<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-line`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.586 38.586a2 2 0 102.828 2.828l32-32a2 2 0 00-2.828-2.828l-32 32z"/></svg>
</template>
<script>

export default {
  name: 'IconLine',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
